export default __webpack_public_path__ + "static/media/journey_01.bed82442.png";